import React, { Fragment, useState } from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { CheckCircle, Flag, X } from "@phosphor-icons/react";
import { Box } from "@mui/material";
import useStore from "../../states/store";
import { reportUser } from "../../config/apisauce";
import ReportCreatorForm from "../Forms/ReportCreatorForm";
import CustomDialog from "./CustomDialog";

export default function ReportCreatorDialog({ reportedUserId }) {
  const [{ loaderState }, { openLoader, closeLoader }] = useStore();

  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("form"); // "form" or "success"

  const handleClickOpen = () => {
    setOpen(true);
    setMode("form");
  };

  const handleClose = () => {
    setOpen(false);
    setMode("form");
  };

  const handleSubmit = async (formValues, resetForm) => {
    openLoader();
    const { ok } = await reportUser({
      ...formValues,
      reportable_type: "App\\Models\\User",
      reportable_id: reportedUserId,
    });

    if (ok) {
      setMode("success");
      resetForm();
    }
    closeLoader();
  };

  const ModeComponentMap = {
    form: <ReportCreatorForm onSubmit={handleSubmit} onClose={handleClose} isLoading={loaderState} />,
    success: <ReportCreatorSuccessView handleClose={handleClose} />,
  };

  return (
    <Fragment>
      <Button onClick={handleClickOpen} sx={{ gap: 1, py: 1.5, px: 3, mt: 1, color: "primary.main" }}>
        <Flag size={16} weight="bold" />
        <Typography sx={{ fontFamily: "Inter", fontWeight: 600, fontSize: "14px", lineHeight: 1 }}>Report profile</Typography>
      </Button>

      <CustomDialog onClose={handleClose} open={open}>
        {ModeComponentMap[mode] ?? <Box p={3}>Invalid mode</Box>}
      </CustomDialog>
    </Fragment>
  );
}

const ReportCreatorSuccessView = ({ handleClose }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <DialogTitle sx={{ m: 0, p: 0 }}>
          <Typography sx={{ fontWeight: 700, fontSize: "24px", color: "primary.main" }}>Report Submitted</Typography>
        </DialogTitle>
        <IconButton aria-label="close" onClick={handleClose} sx={{ color: (theme) => theme.palette.grey[500] }}>
          <X />
        </IconButton>
      </Box>

      <DialogContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            bgcolor: "#DEF2FC",
            color: "primary.main",
            borderRadius: 50,
            height: 150,
          }}
        >
          <CheckCircle size={150} weight="thin" />
        </Box>
        <Typography sx={{ fontSize: "16px", lineHeight: "27px", textAlign: "center" }}>
          Your report has been successfully submitted. Our team will review it shortly.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <Button variant="contained" onClick={handleClose} sx={{ minWidth: "200px" }}>
          OK
        </Button>
      </DialogActions>
    </Box>
  );
};
